import React, { useState } from 'react';
import clsx from 'clsx';
import { v4 as uuidv4 } from 'uuid';
import { BaseTypography, LinearTabs } from 'src/components/common';
import { makeStyles } from '@material-ui/core/styles';
import { IGuestInfo } from 'src/api/base/Guest/types';
import ReactPlayer from 'react-player';
import { Link } from '@material-ui/core';

enum TabValues {
  Images,
  EmbedInterviews,
}

const tabs = [
  { label: 'Photos', value: TabValues.Images },
  { label: 'Videos', value: TabValues.EmbedInterviews },
];

const getListOfMedia = (width: string) => {
  return {
    display: 'grid',
    gridTemplateColumns: `repeat(auto-fill, ${width})`,
    gridGap: '20px',
  };
};
const useStyles = makeStyles((theme) => ({
  body: {
    margin: '20px 0',
  },
  listOfImages: getListOfMedia('190px'),
  listOfVideos: getListOfMedia('250px'),
  listOfLinks: {
    margin: '20px 0',
    display: 'flex',
    gap: '10px',
    flexWrap: 'wrap'
  },
  link: {
    color: theme.palette.primary.main,
  },
  video: {
	borderRadius: '8px',
	overflow: 'hidden', 
	position: 'relative'
  }
}));

const Video: React.FC<{ url: string, comeFrom: string }> = (props) => {
	const { url, comeFrom } = props;
  
	const [canPlay, setCanPlay] = useState<boolean>(ReactPlayer.canPlay(url));
  
	const styles = useStyles();
  
	/* if (url.includes('vimeo.com')) {
	  return (
		<>
		  <Link style={{ width: '100%' }} href={url} target="_blank" rel="noreferrer">
			{url}
		  </Link>
		</>
	  );
	} */
  
	return !canPlay && (
	  <>
		<Link style={{ width: '100%' }} href={url} target="_blank" rel="noreferrer">
		  {url}
		</Link>
		<br/ >
	  </>
	);
  };

type PMediaSection = {
  videos: IGuestInfo['videos'];
  images: IGuestInfo['images'];
  className?: any;
  comeFrom?: string;
};
const checkIsYoutubeLink = (link: string) => link.includes('youtube.com');

export const MediaSection: React.FC<PMediaSection> = (props) => {
  const { videos, images, className, comeFrom } = props;
  const [currentTab, setCurrentTab] = useState(TabValues.Images);
  const classes = useStyles();
  const youtubeVideos = videos.filter(
    (video) => video && checkIsYoutubeLink(video),
  );

  const otherVideos = videos.filter(
    (video) => video && !checkIsYoutubeLink(video),
  );

  const temp_videos = videos.map((url) => (
    <>
      <Video url={url} comeFrom={comeFrom} />
    </>
  ));

  const playableVideos = videos.filter((url) => 
    ReactPlayer.canPlay(url)
  )

  return (
    <div className={clsx(className)}>
      <LinearTabs tabs={tabs} value={currentTab} onTabClick={setCurrentTab} />

      <div className={classes.body}>
        {currentTab === TabValues.Images && (
          <div className={classes.listOfImages}>
			  {images && images.length > 0 ? (
				<>
				{images.map((image) => {
				  return (
					<a href={image.image} target="_blank" rel="noreferrer">
					  <img style={{ borderRadius: '8px', width: '160px', height: '160px', objectFit: 'cover' }} src={image.image} alt="img" key={image.id} />
					</a>
				  );
				})}
				</>
				) : (
					<p>No images found</p>
				)
			  }
          </div>
        )}

        {currentTab === TabValues.EmbedInterviews && (
		  <>
			{videos && videos.length > 0 ? (
			  <div>
				{ /* <div className={classes.listOfVideos}>
				  {youtubeVideos.map((video) => {
					const { searchParams } = new URL(video);
					const videoKey = searchParams.get('v');
					const embedLink = videoKey
					  ? `https://www.youtube.com/embed/${videoKey}`
					  : video;
					return (
					  // eslint-disable-next-line jsx-a11y/media-has-caption
					  <iframe
					    style={{ borderRadius: '8px' }}
						key={videoKey}
						title="YT"
						width="100%"
						height="160px"
						src={embedLink}
						frameBorder="0"
						allow="autoplay; encrypted-media"
						allowFullScreen
					  />
					);
				  })}
				</div>
				<div className={classes.listOfLinks}>
				  {otherVideos.map((video) => {
					return (
					  <BaseTypography variant="tag" key={uuidv4()}>
						<a
						  href={video}
						  target="_blank"
						  rel="noreferrer"
						  className={classes.link}>
						  <video style={{ width: '291px', height: '160px', borderRadius: '8px' }}>
							<source src={video} type="video/mp4" />
							<track
							  kind="captions"
							  // src="/path/to/captions.vtt"
							  srcLang="en"
							  label="English"
							  default
							/>
						  </video>
						</a>
					  </BaseTypography>
					);
				  })}
				</div> */ }
				<div style={{ display: 'flex', gap: '24px', paddingBottom: '24px', marginBottom: '24px', flexWrap: 'wrap' }}>
					{playableVideos?.map((file) => (
						<ReactPlayer
						url={file}
						width={comeFrom === 'popup' ? "150px" : "150px"}
						height={comeFrom === 'popup' ? "150px" : "150px"}
						className={classes.video}
					/>
					))}
					<div>
						{temp_videos}
					</div>
				</div>
			  </div>
			  ) : (
				<p>No Videos found</p>
			  )
			}
		  </>
        )}
      </div>
    </div>
  );
};
